import { useWebSocket } from 'Common/utils/network/querykit/useWebSocket'
import humps from 'humps'

const irisWsHost = import.meta.env.VITE_IRISWS_HOST
const baseWsPath = import.meta.env.VITE_IRISWS_BASEPATH
const imageMeasurementWebsocketUrl = `${irisWsHost}${baseWsPath}measurement/`


export const useImageMeasurement = () =>
  useWebSocket({
    queryKey: ['ams_measurement'],
    url: imageMeasurementWebsocketUrl,
    maxRetries: 3,
    select: (data) => {
      return humps.camelizeKeys(data)
    },
  })
